import { Listing } from "../../../../types/listings.types";

export type ListingsState = {
  listings: {
    data: Listing[];
    hasFetched: boolean;
    isFetching: boolean;
    fetchError: string | null;
  };
};

const selectListingsData = (state: ListingsState) => state.listings.data;
const selectListingIsFetching = (state: ListingsState) =>
  state.listings.isFetching;
const selectListingHasFetched = (state: ListingsState) =>
  state.listings.hasFetched;

export { selectListingHasFetched, selectListingIsFetching, selectListingsData };
